<template>
  <div class="works row align-items-start">
    <div class="col-12 mb-4">
      <h1>Мои работы</h1>
    </div>
    <div class="col-12 d-flex flex-wrap align-items-start">
      <button
        v-for="{ key, title } in filters"
        :key="key"
        class="btn me-3 mb-3"
        :class="key === filter ? 'btn-primary' : 'btn-outline-primary'"
        @click="changeFilter(key)"
      >
        {{ title }}
      </button>
    </div>
    <div class="col-12" v-if="!loading && works.length">
      <div class="row">
        <div class="col-lg-4 col-md-6 mt-3" v-for="work in works" :key="work.id">
          <Work :work="work" :filter="filter" />
        </div>
        <div class="col-12 mt-3 d-flex justify-content-center" v-if="loadMoreShow">
          <button class="btn btn-primary" @click="loadMore">Больше работ</button>
        </div>
      </div>
    </div>
    <div v-else-if="!loading && !works.length" class="mt-3">Тут пока что нет работ</div>
    <div v-else class="loader" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Work from '@/components/Work';

export default {
  name: 'Works',
  data: () => ({
    filters: [
      {
        key: 'all',
        title: 'Все'
      },
      {
        key: 'react',
        title: 'React'
      },
      {
        key: 'vue',
        title: 'Vue'
      },
      {
        key: 'site',
        title: 'Сайты'
      },
      {
        key: 'email',
        title: 'Email-рассылки'
      }
    ]
  }),
  computed: {
    ...mapGetters('works', ['loading', 'works', 'filter', 'worksShow', 'allWorksLength']),
    loadMoreShow() {
      if (this.allWorksLength > this.worksShow && this.allWorksLength >= 6 && this.works.length >= 6) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    loadMore() {
      this.$store.commit('works/loadMore', 3);
    },
    openLoading() {
      const loading = this.$vs.loading();
      setTimeout(() => {
        loading.close();
      }, 3000);
    },
    changeFilter(term) {
      this.$store.commit('works/changeFilter', term);
    }
  },
  async mounted() {
    if (this.loading) {
      this.openLoading();
    }
    await this.$store.dispatch('works/getWorks');
  },
  components: {
    Work
  }
};
</script>

<style lang="scss" scoped>
.works {
  position: relative;

  .loader {
    display: block;
    margin: auto;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 4px solid #e6a23c;
    border-right-color: transparent;
    transform-origin: center;
    animation: rotate 1s linear infinite;
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
